import React from 'react';
import { TaskDefinitionSummary } from '../types';
import { Edit3 } from 'lucide-react';

interface TemplateDropdownProps {
  templates: TaskDefinitionSummary[];
  selected: string;
  onChange: (templateId: string) => void;
  onSettingsClick?: () => void;
  onAddTemplateClick?: () => void;
}

export const TemplateDropdown: React.FC<TemplateDropdownProps> = ({
  templates,
  selected,
  onChange,
  onSettingsClick,
  // onAddTemplateClick, // Temporarily disabled - Add PDF Template feature
}) => {

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    // Temporarily disabled - Add PDF Template feature
    // if (value === 'add-template') {
    //   onAddTemplateClick?.();
    // } else {
    //   onChange(value);
    // }
    onChange(value);
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <select
            id="template-select"
            className="select select-bordered w-full text-base border-2 border-base-300 focus:border-primary focus:ring-2 focus:ring-primary/20"
            value={selected}
            onChange={handleSelectChange}
          >
            <option value="" disabled>
              Select a template...
            </option>
            {templates.map((template) => (
              <option key={template.id} value={template.id}>
                {template.name}
              </option>
            ))}
            {/* Temporarily disabled - Add PDF Template feature */}
            {/* <option value="add-template" className="text-primary font-medium">
              + Add PDF Template
            </option> */}
          </select>
        </div>
        {selected && (() => {
          const selectedTemplate = templates.find(t => t.id === selected);
          if (!selectedTemplate) return null;
          
          // Only show settings for DocumentPopulation tasks
          if (selectedTemplate.taskType === 'DocumentPopulation' && onSettingsClick) {
            return (
              <button
                type="button"
                className="btn btn-outline btn-sm whitespace-nowrap border-[0.5px]"
                onClick={onSettingsClick}
                aria-label="Edit template"
              >
                <Edit3 size={16} className="mr-1.5" strokeWidth={1.5} />
                Edit Template
              </button>
            );
          }
          return null;
        })()}
      </div>
    </div>
  );
}; 